import { Injectable } from '@angular/core';
import { LocalStorageService } from '../../../../services/local-storage.service';
import { NavRoute } from '../../../../interfaces/nav-route';
import { libraryRoutes } from './libraries.constants';
import {
	Building2,
	DollarSign,
	Folder, ImportIcon,
	ListTodo,
	Megaphone,
	Paintbrush,
	ScanBarcode,
	SlidersHorizontal,
	SwatchBook,
	Target,
	Users,
} from 'lucide-angular';
import { UserRoles } from '../../../../helpers';

@Injectable({
	providedIn: 'root',
})
export class LibrariesService {
	constructor(private localStorageService: LocalStorageService) {}

	private canUploadDocuments(): boolean {
		const currentUser = this.localStorageService.getUserDetails();
		return currentUser.entity?.canUploadCustomDocuments;
	}

	private canImportData(): boolean {
		const currentUser = this.localStorageService.getUserDetails();
		return currentUser.entity?.canImportData && currentUser.role === UserRoles.superAdmin.key;
	}

	getRoutes(): NavRoute[] {
		return [
			{ name: 'Brands', route: `/libraries/${libraryRoutes.brands}`, icon: Building2},
			{ name: 'Products', route: `/libraries/${libraryRoutes.products}`, icon: ScanBarcode},
			{ name: 'Colours', route: `/libraries/${libraryRoutes.colours}`, icon: SwatchBook },
			{ name: 'Coating Systems', route: `/libraries/${libraryRoutes.coatingSystems}`, icon: SlidersHorizontal },
			{ name: 'Labour Rates', route: `/libraries/${libraryRoutes.labourRates}`, icon: DollarSign},
			{ name: 'Measure Tools', route: `/libraries/${libraryRoutes.measureTools}`, icon: Paintbrush },
			{ name: 'Suppliers', route: `/libraries/${libraryRoutes.suppliers}`, icon: Users},
			{
				name: 'Files/Folders',
				route: `/libraries/${libraryRoutes.fileFolders}`,
				icon: Folder,
				disabled: !this.canUploadDocuments(),
				subRoutes: [
					{ name: 'Tender Document', route: `/libraries/${libraryRoutes.fileFolders}/${libraryRoutes.tenderDocument}`},
					{ name: 'Quote Proposal', route: `/libraries/${libraryRoutes.fileFolders}/${libraryRoutes.quoteProposal}`},
					{ name: 'Office Folder', route: `/libraries/${libraryRoutes.fileFolders}/${libraryRoutes.officeFolder}`},
					{ name: 'Site Folder', route: `/libraries/${libraryRoutes.fileFolders}/${libraryRoutes.siteFolder}`},
					{ name: 'Safety Folder', route: `/libraries/${libraryRoutes.fileFolders}/${libraryRoutes.safetyFolder}`},
					{ name: 'QA Folder', route: `/libraries/${libraryRoutes.fileFolders}/${libraryRoutes.qaFolder}`},
					{ name: 'Variation Quote', route: `/libraries/${libraryRoutes.fileFolders}/${libraryRoutes.variationQuote}`},
					{ name: 'Quote', route: `/libraries/${libraryRoutes.fileFolders}/${libraryRoutes.quote}`},
					{ name: 'Bill of Quantity', route: `/libraries/${libraryRoutes.fileFolders}/${libraryRoutes.boq}`},
					{ name: 'Product Purchasing', route: `/libraries/${libraryRoutes.fileFolders}/${libraryRoutes.productPurchasing}`},
					{ name: 'Invoice', route: `/libraries/${libraryRoutes.fileFolders}/${libraryRoutes.invoice}`},
					{ name: 'Subcontracting Agreement', route: `/libraries/${libraryRoutes.fileFolders}/${libraryRoutes.subcontractingAgreement}`},
					{ name: 'Policies', route: `/libraries/${libraryRoutes.fileFolders}/${libraryRoutes.policies}`},
					{ name: 'Procedures', route: `/libraries/${libraryRoutes.fileFolders}/${libraryRoutes.procedures}`},
				]
			},
			{ name: 'Scope', route: `/libraries/${libraryRoutes.scope}`, icon: ListTodo},
			{ name: 'Marketing Items', route: `/libraries/${libraryRoutes.marketingItems}`, icon: Megaphone},
			{ name: 'Competitors', route: `/libraries/${libraryRoutes.competitors}`, icon: Target },
			{ name: 'Import Data', route: `/libraries/${libraryRoutes.importData}`, icon: ImportIcon, disabled: !this.canImportData(), },
		]
	}
}
